import { c as _c } from "react/compiler-runtime";
import { LocaleMessageType } from "@/types/locale";
import { PropsWithClassName } from "@/types/ui";
import React from "react";
import { useLocale } from "next-intl";
import { ExternalLink } from "@components/common/external-link";
import { localizeFrom } from "@lib/i18n/utils";
export const EventSiteLink = t0 => {
  const $ = _c(10);
  const {
    className,
    link,
    title
  } = t0;
  const locale = useLocale();
  if (!link || !title) {
    return null;
  }
  let t1;
  if ($[0] !== link || $[1] !== locale) {
    t1 = localizeFrom(link, locale);
    $[0] = link;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== locale || $[4] !== title) {
    t2 = localizeFrom(title, locale);
    $[3] = locale;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== className || $[7] !== t1 || $[8] !== t2) {
    t3 = <ExternalLink href={t1} className={className}>{t2}</ExternalLink>;
    $[6] = className;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};